export default {
  state: () => ({
    fastCashbackGameIds: [],
    competitionsGameIds: [],
    groupListWithImages: [],
  }),
  actions: {
    setGroupListWithImages({ commit }, value) {
      commit('SET_GROUP_LIST_WITH_IMAGES', value)
    },
  },
  mutations: {
    UPDATE_FAST_CASHBACK_GAME_IDS(state, value) {
      state.fastCashbackGameIds = value
    },
    UPDATE_COMPETITIONS_GAME_IDS(state, value) {
      state.competitionsGameIds = value
    },
    SET_GROUP_LIST_WITH_IMAGES(state, value) {
      state.groupListWithImages = value
    }
  },
  getters: {
    isFastCashbackGame: (s) => (id) => s.fastCashbackGameIds.includes(id),
    isCompetitionGame: (s) => (id) => s.competitionsGameIds.includes(id),
  },
}
